<template>
    <div>
        <h1>Home screen</h1>
        <p>Välkommen till management för Däckpatrullens hemsida</p>
    </div>
</template>
<script>
export default {
    name: "Home"
}
</script>
<style lang="">
    
</style>